import Velocity from 'velocity-animate'
import 'velocity-animate/velocity.ui'
import {
  extend,
  get,
  isFunction,
} from 'lodash-es'

// ///////////////////////////////
// Validation Animations Mixin //
// ///////////////////////////////

export default {
  /**
  * event handler that opens the drawer below an
  * input field to display a validation error.
  *
  * @return {null} no return
  */
  showValidationBlock: (element, opts, cb) => {
    const options = extend(opts, {})
    const prevHeight = (element && element.offsetHeight) || 0
    const padding = get(options, 'padding') ? get(options, 'padding') : 0

    element.style.setProperty('display', 'block')
    element.style.setProperty('height', 'auto')

    const fullHeight = element.offsetHeight + padding

    element.style.setProperty('display', 'block')
    element.style.setProperty('height', `${prevHeight}px`)

    const mySequence = [{
      e: element,
      p: { height: fullHeight },
      o: {
        duration: 350,
        easing: 'easeOutQuint',
        complete: () => {
          element.style.setProperty('height', 'inherit')
          element.style.setProperty('display', 'block')
          if (isFunction(cb)) cb.call()
        },
      },
    }]

    Velocity.RunSequence(mySequence)
  },

  /**
  * Event handler to hide the validation block whenever
  * the validation state is valid or has been cleared for
  * other circumstances.
  *
  * @return {null} no return
  */
  hideValidationBlock: (element, opts = {}, cb) => {
    const duration = 350

    if (opts.force === true) {
      const mySequence = [{
        e: element,
        p: { height: 0 },
        o: {
          duration,
          easing: 'easeOutQuint',
          complete: () => {
            element.style.setProperty('display', 'none')
            if (isFunction(cb)) cb.call()
          },
        },
      }]

      Velocity.RunSequence(mySequence)
    } else {
      const mySequence = [{
        e: element,
        p: { height: 0 },
        o: {
          duration,
          easing: 'easeOutQuint',
          complete: () => {
            element.style.setProperty('display', 'none')
            if (isFunction(cb)) cb.call()
          },
        },
      }]

      Velocity.RunSequence(mySequence)
    }
  },
}
